<div class="tab-component">
  <div class="tab-component-wrapper">
    <div class="tab-title">
      <h3>Device Config History</h3>
    </div>

    <div class="tab-content">
        <div class="tab-content-wrapper content-wrapper-aggrid">
          <div class="component-ag-grid-wrapper device-config-history-grid-shell"
            [style.--mc-ag-host-height.px]="gridHostHeightPx"
            (contextmenu)="preventDefaultContextMenu($event)"
          mcAgGridCopyCellTooltip style="position: relative;">
            <ag-grid-angular
              style="width: 100%;"
              class="ag-theme-alpine"
              [rowData]="rowData"
              [rowModelType]="'infinite'"
              [columnDefs]="columnDefs"
              [defaultColDef]="defaultColDef"
              (gridReady)="onGridReady($event)"
              (cellContextMenu)="onCellContextMenu($event)"
              [pagination]="true"
              [paginationPageSize]="paginationPageSize"
            [paginationPageSizeSelector]="pageSizeOptions"
              (paginationChanged)="onPaginationChanged($event)"
              [cacheBlockSize]="paginationPageSize"
              [maxBlocksInCache]="2"



              >
            </ag-grid-angular>
            <div class="custom-context-menu" *ngIf="contextMenu.visible" [ngStyle]="{'top.px': contextMenu.y, 'left.px': contextMenu.x}">
              <ul>
                <li (click)="copyToClipboard(contextMenu.value)">Copy Value</li>
              </ul>
            </div>
          </div>
        </div>
    </div>
  </div>
</div>

